import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Asignar.css";
import API from "../api";

const Asignar = () => {
  const [conductores, setConductores] = useState([]);
  const [selectedConductor, setSelectedConductor] = useState(null);
  const [loadingId, setLoadingId] = useState(null);
  const navigate = useNavigate();

  const fetchConductores = () => {
    fetch(`${API}/conductores`)
      .then((res) => res.json())
      .then((data) => setConductores(Array.isArray(data) ? data : []))
      .catch((err) => console.error("Error:", err));
  };

  useEffect(() => {
    fetchConductores();
  }, []);

  const eliminarAsignacion = async (idConductor) => {
    const ok = window.confirm("¿Seguro que deseas eliminar la asignación de viáticos?");
    if (!ok) return;
    try {
      setLoadingId(idConductor);
      const res = await fetch(`${API}/eliminar/${idConductor}`, { method: "DELETE" });
      const data = await res.json();
      if (!res.ok) throw new Error(data?.message || "Error al eliminar asignación");

      setConductores((prev) =>
        prev.map((x) =>
          x.Id_conductor === idConductor
            ? { ...x, estado_viatico: "Sin asignar", salida: null, destino: null, gasolina: null, tiempo: null, alimentacion: null }
            : x
        )
      );

      if (selectedConductor?.Id_conductor === idConductor) setSelectedConductor(null);
    } catch (e) {
      console.error(e);
      alert("No se pudo eliminar la asignación. Revisa la consola.");
    } finally {
      setLoadingId(null);
    }
  };

  return (
    <div className="asignar-container">
      <h1>Asignar Viáticos</h1>

      
      <button
        onClick={() => navigate("/dashboard")}
        style={{
          marginBottom: "15px",
          padding: "10px 20px",
          background: "#2563eb",
          color: "white",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
        }}
      >
        Menú Principal
      </button>

      <table className="asignar-table">
        <thead>
          <tr>
            <th>Conductor</th>
            <th>Teléfono</th>
            <th>DPI</th>
            <th>Estado Viático</th>
            <th>Acción</th>
          </tr>
        </thead>
        <tbody>
          {conductores.map((c) => (
            <tr key={c.Id_conductor}>
              <td>{c.Nombres} {c.Apellidos}</td>
              <td>{c.Telefono}</td>
              <td>{c.Dpi}</td>
              <td>
                <span
                  className={c.estado_viatico === "Asignado" ? "estado asignado" : "estado sin-asignar"}
                >
                  {c.estado_viatico}
                </span>
              </td>
              <td>
                {c.estado_viatico === "Asignado" ? (
                  <>
                    <button className="btn-detalle" onClick={() => setSelectedConductor(c)}>
                      Ver Detalles
                    </button>
                    <button
                      className="btn-eliminar"
                      onClick={() => eliminarAsignacion(c.Id_conductor)}
                      disabled={loadingId === c.Id_conductor}
                    >
                      {loadingId === c.Id_conductor ? "Eliminando..." : "Eliminar"}
                    </button>
                  </>
                ) : (
                  <button
                    className="btn-asignar"
                    onClick={() => navigate(`/formulario-viatico/${c.Id_conductor}`)}
                  >
                    Asignar Viáticos
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Modal de detalles */}
      {selectedConductor && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h2>Detalles de Viáticos</h2>
            <p><b>Conductor:</b> {selectedConductor.Nombres} {selectedConductor.Apellidos}</p>
            <p><b>Salida:</b> {selectedConductor.salida || "-"}</p>
            <p><b>Destino:</b> {selectedConductor.destino || "-"}</p>
            <p><b>Gasolina:</b> {selectedConductor.gasolina != null ? `Q${selectedConductor.gasolina}` : "-"}</p>
            <p><b>Tiempo:</b> {selectedConductor.tiempo != null ? `${selectedConductor.tiempo} hrs` : "-"}</p>
            <p><b>Alimentación:</b> {selectedConductor.alimentacion != null ? `Q${selectedConductor.alimentacion}` : "-"}</p>

            <div className="modal-footer">
              <button className="btn-cerrar" onClick={() => setSelectedConductor(null)}>
                Cerrar
              </button>
              <button
                className="btn-eliminar"
                onClick={() => eliminarAsignacion(selectedConductor.Id_conductor)}
                disabled={loadingId === selectedConductor.Id_conductor}
              >
                {loadingId === selectedConductor.Id_conductor ? "Eliminando..." : "Eliminar Asignación"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Asignar;
